import type {WorkspaceModelType} from "@stores/WorkspaceStore";
import type {RootStoreModel} from "@stores/RootStore";


import {screenSizeProvider} from "@stores/ScreenSizeProvider";


export const selectItem = (rootStore: RootStoreModel, selectedId: string) => {
    const workspace = rootStore.view.workspace!;
    const selectedItem = workspace.items.get(selectedId)!;
    if (selectedItem === undefined) {
        return;
    }
    if (selectedItem.getParentPaths().length > 0) {
        for (const firstPathAncestorId of selectedItem.getParentPaths()[0]) {
            const firstPathAncestor = workspace.items.get(firstPathAncestorId)!;
            firstPathAncestor.setExpanded(true);
        }
    }
    workspace.setScrollIntoViewId(selectedId);
    selectItemPlain(rootStore, workspace, selectedId);
}

export const selectItemPlain = (rootStore: RootStoreModel, workspace: WorkspaceModelType, selectedId: string | null) => {
    rootStore.view.openPageByName('docEdit', {id: selectedId ? selectedId : undefined});
    if (!selectedId || workspace.items.get(selectedId)?.isCluster) {
        rootStore.setRightMenu('');
    }
    const isMobile = screenSizeProvider.view !== 'desktop';
    if (isMobile) {
        rootStore.toggleIsTreeCollapsed(true);
    }
}
